/** Parser for POST `/earn/portfolio/summary`. */

import { parseU64OrZero } from "@bridgesplit/utils";

import { EarnPortfolioSummaryPositionApi } from "../api/earn-summary";
import { EarnPortfolioSummaryPosition } from "../domain/earn-summary";

function parseEarnPortfolioSummaryPositionFromApi(api: EarnPortfolioSummaryPositionApi): EarnPortfolioSummaryPosition {
    return {
        depositMint: api.depositMint,
        vaultAddresses: api.vaultAddresses,
        positionValueAssets: parseU64OrZero(api.positionValueAssets),
        positionValueUsd: api.positionValueUsd,
        costBasisAssets: parseU64OrZero(api.costBasisAssets),
        unrealizedPnlAssets: parseU64OrZero(api.unrealizedPnlAssets),
        realizedPnlAssets: parseU64OrZero(api.realizedPnlAssets),
        apyBps: api.apyBps ?? undefined
    };
}

export function parseEarnPortfolioSummaryFromApi(
    api: EarnPortfolioSummaryPositionApi[]
): EarnPortfolioSummaryPosition[] {
    return api.map(parseEarnPortfolioSummaryPositionFromApi);
}
